import React from 'react';
import { Button, Box, Spinner } from '@updater/ui-uds';
import { useSingleLineAddressInputContext } from './context';

export interface ContinueButtonProps {
  label?: string;
  size?: 's' | 'm' | 'l';
}

/**
 * Continue button - always visible but disabled until address is validated
 * Enabled when state is 'ready'
 */
export function ContinueButton({
  label = 'Continue',
  size = 'l',
}: ContinueButtonProps) {
  const { state, onContinue, isValidating } =
    useSingleLineAddressInputContext();

  const isReady = state === 'ready';
  const isDisabled = !isReady || isValidating;

  return (
    <Box mt="m" width="100%">
      <Button
        onClick={onContinue}
        size={size}
        isFluidWidth
        disabled={isDisabled}
        aria-label={isValidating ? 'Loading' : label}
      >
        {isValidating ? <Spinner mx="auto" size="s" /> : label}
      </Button>
    </Box>
  );
}
